import request from "../request";

//测试
export function test() {
    return request({
        url: window.g.VUE_APP_URL + '/appoint',
        method: 'get'
    })
}

/**
 * 查询体检报告
 * @param params
 */
export function reportDetail(params) {
    return request({
        url: window.g.VUE_APP_URL + '/api/reportDetail',
        method: 'post',
        data: params
    })
}

/**
 * 获取体检套餐
 * @param params
 * @returns {AxiosPromise}
 */
export function getDefualtPackage(params) {
    return request({
        url: window.g.VUE_APP_URL + '/package/getDefaultPackageList',
        method: 'post',
        data: params,
        hideLoading:false
    })
}
/**
 * 获取体检检线数据
 * @param params
 * @returns {AxiosPromise}
 */
export function getCheckLineList(params) {
    return request({
        url: window.g.VUE_APP_URL + '/package/getCheckLineList',
        method: 'get'
    })
}

/**
 * 获取体检套餐详情
 * @param params
 * @returns {AxiosPromise}
 */
export function getPackageDetialByPackageId(params) {
    return request({
        url: window.g.VUE_APP_URL + '/package/getPackageDetialByPackageId',
        method: 'get',
        params: params,
        hideLoading:true
    })
}

/**
 * 获取推荐热门套餐
 * @returns {AxiosPromise}
 */
export function getTopPackageList(params) {
    return request({
        url: window.g.VUE_APP_URL + '/package/getTopPackageList',
        method: 'get',
        data: params,
        hideLoading:true
    })
}
/**
 * 获取年龄段
 * @returns {AxiosPromise}
 */
export function getAgeStageIdList(params) {
    return request({
        url: window.g.VUE_APP_URL + '/package/getAgeStageIdList',
        method: 'get',
        params: params,
        hideLoading:true
    })
}
/**
 * 获取单位套餐列表
 * @param params
 * @returns {AxiosPromise}
 */
export function getPackageListByCompanyId(params) {
    return request({
        url: window.g.VUE_APP_URL + '/package/getPackageListByCompanyId',
        method: 'get',
        params: params,
        hideLoading:true
    })
}

//获取组合列表
export function getGroupInfoList(params) {
    return request({
        url: window.g.VUE_APP_URL + '/group/getGroupInfoList',
        method: 'post',
        data: params,
        hideLoading:true
    })
}
//获取单位优惠组合列表
export function getCompanyGiveGroups(params) {
    return request({
        url: window.g.VUE_APP_URL + '/getCompanyGiveGroups',
        method: 'get',
        params: params,
        hideLoading:true
    })
}

//组合排斥和关联
export function getExcludeInfoList(params) {
    return request({
        url: window.g.VUE_APP_URL + '/exclude/getExcludeInfoList',
        method: 'get',
        params:params,
        hideLoading:true
    })
}

//问卷
export function getQuestionsAndOptionsProced(params) {
    return request({
        url: window.g.VUE_APP_URL + '/question/getQuestionsAndOptionsProced',
        method: 'post',
        data: params
    })
}

//问卷和题目集合
export function selectQuestionsAndOptions(params) {
    return request({
        url: window.g.VUE_APP_URL + '/question/selectQuestionsAndOptions',
        method: 'get',
        params:params,
        hideLoading:true
    })
}

//获取排他题目
export function  getExcludeQuestions(params){
    return request({
        url: window.g.VUE_APP_URL + '/question/getExcludeQuestions',
        method: 'get',
        params: params
    })
}
//获取关联题目
export function  getRelationQuestions(params){
    return request({
        url: window.g.VUE_APP_URL + '/question/getRelationQuestions',
        method: 'get',
        params: params
    })
}

//满意度调查题目和集合
export function selectSurveyAndOptions() {
    return request({
        url: window.g.VUE_APP_URL + '/question/selectSurveyAndOptions',
        method: 'get'
    })
}

//添加预约信息表
export function addBookedPatient(params) {
    return request({
        url: window.g.VUE_APP_URL + '/question/addBookedPatient',
        method: 'post',
        data: params
    })
}

export function addQuestionnaire(params) {
    return request({
        url: window.g.VUE_APP_URL + '/question/addQuestionnaire',
        method: 'post',
        data: params
    })
}

//清除问卷信息及预约人员信息
export function delBookedPatientAndQuestionnaire(params) {
    return request({
        url: window.g.VUE_APP_URL + '/question/delBookedPatientAndQuestionnaire',
        method: 'post',
        data: params
    })
}


//满意度调查提交
export function addQuestionnaireAnswer(params) {
    return request({
        url: window.g.VUE_APP_URL + '/question/addQuestionnaireAnswer',
        method: 'post',
        data: params
    })
}

//加做项目
export function plusGroups(params) {
    return request({
        url: window.g.VUE_APP_URL + '/plusGroups',
        method: 'post',
        data: params
    })
}

//删除项目
export function minusGroups(params) {
    return request({
        url: window.g.VUE_APP_URL + '/minusGroups',
        method: 'post',
        data: params
    })
}
//根据patientid获取问卷列表
export function getQuestionnaireListByPatientid(params) {
    return request({
        url: window.g.VUE_APP_URL + '/question/getQuestionnaireListByPatientid',
        method: 'get',
        params: params
    })
}
//根据patientid获取当日签到列表
export function getQueueregistByPatientid(params) {
    return request({
        url: window.g.VUE_APP_URL + '/question/getQueueregistByPatientid',
        method: 'get',
        params: params
    })
}
//根据问卷类别名称获取问卷ID
export function getQuestionnaireTypeID(params) {
    return request({
        url: window.g.VUE_APP_URL + '/question/getQuestionnaireTypeID',
        method: 'get',
        params: params
    })
}
//根据问卷答案列表根据流水号
export function getQuestionnaireAnswer(params) {
    return request({
        url: window.g.VUE_APP_URL + '/question/getQuestionnaireAnswer',
        method: 'get',
        params: params
    })
}
//是否可以做满意度调查问卷
export function getLt30DayMedicalRecord(params) {
    return request({
        url: window.g.VUE_APP_URL + '/question/getLt30DayMedicalRecord',
        method: 'get',
        params: params
    })
}
//满意度调查问卷返回流水号
export function getLt30DayMedicalSerialno(params) {
    return request({
        url: window.g.VUE_APP_URL + '/question/getLt30DayMedicalSerialno',
        method: 'get',
        params: params
    })
}

//根据流水号返回支付地址
export function getPayUrlBySerialno(params) {
    return request({
        url: window.g.VUE_APP_URL + '/pay/getPayUrlBySerialno',
        method: 'get',
        params: params
    })
}
//根据预约号或者流水号查询支付回写状态
export function getPayStatus(params) {
    return request({
        url: window.g.VUE_APP_URL + '/pay/getPayStatus',
        method: 'get',
        params: params,
        hideLoading:true
    })
}
//根据收费记录号查询退费记录条数
export function getChargeRefundCount(params) {
    return request({
        url: window.g.VUE_APP_URL + '/pay/getChargeRefundCount',
        method: 'get',
        params: params,
        hideLoading:true
    })
}

//根据流水号返回支付地址
export function getPaymentUrlByBookedNo(params) {
    return request({
        url: window.g.VUE_APP_URL + '/api/getPaymentUrlByBookedNo',
        method: 'post',
        params: params
    })
}
//根据流水号返回订单明细
export function getPayDetailBySerialno(params) {
    return request({
        url: window.g.VUE_APP_URL + '/pay/getPayDetailBySerialno',
        method: 'get',
        params: params
    })
}
//根据流水号返回订单明细
export function toIcbcPay(params) {
    return request({
        url: window.g.VUE_APP_URL + '/pay/toIcbcPay',
        method: 'get',
        params:params
    })
}
//根据人员id查询待办任务
export function getConsentFormCount(params) {
    return request({
        url: window.g.VUE_APP_URL + '/consentForm/getConsentFormCount',
        method: 'get',
        params: params
    })
}

//根据人员id查询待办任务列表
export function getConsentFormList(params) {
    return request({
        url: window.g.VUE_APP_URL + '/consentForm/getConsentFormList',
        method: 'get',
        params: params
    })
}

// 查询签署信息
export function getSignatureInfo(params){
    return request({
        url: window.g.VUE_APP_URL + '/consentForm/getSignatureInfo',
        method: 'get',
        params: params
    })
}

//上传文件
export function signatureConsentForm(params) {
    return request({
        url: window.g.VUE_APP_URL + '/consentForm/signatureConsentForm',
        method: 'post',
        data: params
    })
}

// 查询签署信息
export function getSignatureImage(params){
    return request({
        url: window.g.VUE_APP_URL + '/consentForm/getSignatureImage',
        method: 'get',
        params: params
    })
}

// 根据PatientID查询用户信息
export function getUserInfoByPatientid(params){
    return request({
        url: window.g.VUE_APP_URL + '/getUserInfoByPatientidDaoJian',
        method: 'get',
        params: params
    })
}

// 根据身份证、手机号、姓名查询用户信息
export function getUserInfoByCarId(params){
    return request({
        url: window.g.VUE_APP_URL + '/getUserInfoByCarId',
        method: 'get',
        params: params
    })
}

//问卷和题目集合
export function getPsychologicalListByPatientid(params) {
    return request({
        url: window.g.VUE_APP_URL + '/question/getPsychologicalListByPatientid',
        method: 'get',
        params:params,
        hideLoading:true
    })
}

//心理问卷提交
export function addQuestionnaireAnswerPsychological(params) {
    return request({
        url: window.g.VUE_APP_URL + '/question/addQuestionnaireAnswerPsychological',
        method: 'post',
        data: params
    })
}

// bookedNo 查询当前预约号 是否可以 答检前问卷
//serialNo 查询当前流水号 是否可以 答满意度调查问卷
export function getQuestionIsTrue(params) {
    return request({
        url: window.g.VUE_APP_URL + '/question/getQuestionIsTrue',
        method: 'get',
        params:params,
        hideLoading:true
    })
}
//个人预约页面刚进入的时候判断是否弹出做问卷
export function getQuestionIsTrueForPersonal(params) {
    return request({
        url: window.g.VUE_APP_URL + '/question/getQuestionIsTrueForPersonal',
        method: 'get',
        params:params,
        hideLoading:true
    })
}

//根据体检编号查询健康证列表
export function getHealthCardList(params) {
    return request({
        url: window.g.VUE_APP_URL + '/healthCard/getHealthCardList',
        method: 'get',
        params:params,
        hideLoading:true
    })
}

// 根据流水号查询健康证
export function getHealthCardInfo(params) {
    return request({
        url: window.g.VUE_APP_URL + '/healthCard/getHealthCardInfo',
        method: 'get',
        params:params,
        hideLoading:true
    })
}

//微信登陆绑定账号
export function bindingPhysicalNo(params){
    return request({
        url: window.g.VUE_APP_URL + '/bindingPhysicalNo',
        method: 'post',
        params: params
    })
}

//获取体检正式登记未支付的订单
export  function getMedicalOrders(params){
    return request({
        url: window.g.VUE_APP_URL + '/getMedicalOrders',
        method: 'get',
        params:params,
        hideLoading:true
    })
}


//根据人员id查询消息条数
export function getWeChatMessageCount(params) {
    return request({
        url: window.g.VUE_APP_URL + '/weChatMessage/getWeChatMessageCount',
        method: 'get',
        params: params,
        hideLoading:true
    })
}


//根据人员id查询消息列表
export function getWeChatMessage(params) {
    return request({
        url: window.g.VUE_APP_URL + '/weChatMessage/getWeChatMessage',
        method: 'get',
        params: params
    })
}
// 根据消息id变更状态
export function checkWeChatMessage(params){
    return request({
        url: window.g.VUE_APP_URL + '/weChatMessage/checkWeChatMessage',
        method: 'post',
        params: params
    })
}
//根据流水号查询有云胶片的项目
export function getCloudFilmBySerialNo(params) {
    return request({
        url: window.g.VUE_APP_URL + '/group/getCloudFilmBySerialNo',
        method: 'get',
        params: params
    })
}

// 获取医院机构代码
export function getHospitalCode() {
    return request({
        url: window.g.VUE_APP_URL + '/getHospitalCode',
        method: 'get',
    })
}

//根据流水号查询有云胶片的项目;查fileType
export function getCloudFilmBySerialNoByFileType(params) {
    return request({
        url: window.g.VUE_APP_URL + '/group/getCloudFilmBySerialNoByFileType',
        method: 'get',
        params: params
    })
}

//更新患者id
export function updatePatientId(params) {
    return request({
        url: window.g.VUE_APP_URL + '/updatePatientId',
        method: 'post',
        params: params
    })
}
